import React from 'react';

import { Box, Typography } from 'components';

import { useTranslation } from 'third-party';

export const Disclaimer = () => {
  const { t } = useTranslation();

  return (
    <Box>
      <>
        <Box
          sx={{
            width: '100%',
            position: 'relative',
            paddingBottom: '0.3rem',
          }}
        >
          <Typography
            variant="h2"
            sx={{
              textAlign: 'center',
              width: '100%',
            }}
          >
            {t('legal.disclaimer.header')}
          </Typography>
        </Box>

        <Box sx={{ paddingBottom: '1rem', textAlign: 'center' }}>
          <Typography variant="subtitle1" sx={{ paddingTop: '0.8rem' }}>
            {t('legal.disclaimer.subHeader')}
          </Typography>
        </Box>

        <Box
          sx={{
            margin: '0 auto',
            padding: '1rem',
            maxHeight: '70vh',
            overflow: 'auto',
          }}
        >
          <Typography variant="body2" paragraph>
            EasyECheck.online is a platform that provides tools for managing and
            delivering electronic checks. EasyECheck.online is not a bank or a
            financial institution and does not offer banking or FDIC-insured
            services. All check processing and funds transfer activities must be
            completed through third-party financial services or banks
            independently engaged by users.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            WEBSITE DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            The information provided by EasyECheck ("we," "us," or "our") on
            https://easyecheck.online (the "Site") and through any associated
            services is for general informational purposes only. All content is
            provided in good faith; however, we make no representations or
            warranties of any kind—express or implied—regarding the accuracy,
            adequacy, validity, reliability, availability, or completeness of
            any information on the Site.
          </Typography>
          <Typography variant="body2" paragraph>
            UNDER NO CIRCUMSTANCE shall we have any liability to you for any
            loss or damage incurred as a result of your use of the Site or
            reliance on any information provided. YOUR USE OF THE SITE AND ANY
            RELIANCE ON ITS INFORMATION IS SOLELY AT YOUR OWN RISK.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            EXTERNAL LINKS DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            The Site may contain links to third-party websites, services, or
            content. These are provided for convenience only. We do not
            investigate, monitor, or guarantee the accuracy or completeness of
            third-party content. We are not responsible for and do not endorse
            or assume liability for any third-party websites, services, or
            advertising linked through the Site. Any transaction between you and
            third-party providers is strictly between you and the third party.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            PROFESSIONAL DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            EasyECheck.online does not offer legal, tax, financial, or
            accounting advice. All information is provided for general
            educational and informational purposes only. You should consult with
            a qualified professional before making decisions based on any
            content on the Site. RELIANCE ON ANY INFORMATION PROVIDED BY THE
            SITE IS AT YOUR OWN RISK.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            AFFILIATES DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            The Site may include links to affiliate partners. We may receive a
            commission if you make a purchase through these links. This does not
            affect the price you pay and does not influence our recommendations.
          </Typography>

          <Typography variant="h6" sx={{ mt: 3, mb: 1, fontWeight: 'bold' }}>
            TESTIMONIALS DISCLAIMER
          </Typography>
          <Typography variant="body2" paragraph>
            The Site may display testimonials from users. These are individual
            experiences and may not reflect the experience of all users. We do
            not guarantee similar results. Testimonials may be edited for
            clarity or length but are otherwise presented as submitted.
          </Typography>
          <Typography variant="body2" paragraph>
            Testimonials do not constitute claims or guarantees of any kind and
            should not be interpreted as such.
          </Typography>
        </Box>
      </>
    </Box>
  );
};
